export default __webpack_public_path__ + "link-symbol.png";